import React, {useState} from 'react';
import CallCenterStructure from '../CallCenterStructure/CallCenterStructure';
import Dropdown from '../../component/DropDown/DropDown';
import SearchInput from '../../component/SearchInput/SearchInput';
import {Times, ViewPen} from '../../assets/icons';
import styles from '../../styles/DataMappingForEnrollment.module.scss';
import ClearInputModal from '../../component/ClearInputModal/ClearInputModal';

const DataMappingForEnrollment = () => {
  const [clearModal, setClearModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const onClose = () => {
    setDeleteModal(false);
  };

  const tableData = [
    {
      id: 4,
      name: 'Fidelity Green Rewards',
      code: 'Lsl-THE OTH 521627',
      groupName: 'Granny Nuts Natural Almond',
      itemName: 'candy',

      brandName: 'The Store',
      price: '139150 Points',
    },
    {
      id: 3,
      name: 'Fidelity Green Rewards',
      code: 'Lsl-THE OTH 521627',
      groupName: 'Granny Nuts Natural Almond',
      itemName: 'candy',

      brandName: 'The Store',
      price: '139150 Points',
    },
    {
      id: 9,
      name: 'Fidelity Green Rewards',
      code: 'Lsl-THE OTH 521627',
      groupName: 'Granny Nuts Natural Almond',
      itemName: 'candy',

      brandName: 'The Store',
      price: '139150 Points',
    },
    {
      id: 6,
      name: 'Fidelity Green Rewards',
      code: 'Lsl-THE OTH 521627',
      groupName: 'Granny Nuts Natural Almond',
      itemName: 'candy',

      brandName: 'The Store',
      price: '139150 Points',
    },
    ,
  ];
  return (
    <div>
      <CallCenterStructure>
        <div className={styles.PoSItemOpeningBalanceMaster}>
          <div className={styles.headerText}>
            <p>Data Mapping for Enrollment</p>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.field1}>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Select Loyalty Program<sup>*</sup>
                </label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Date Format ("dd-mm-yyyy")
                  <sup>*</sup>
                </label>
                <input type="text" />
              </div>
            </div>

            <div className={styles.field2}>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Name for Data Mapping File<sup>*</sup>
                </label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter No. of Header Rows<sup>*</sup>
                </label>
                <input type="text" />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Column No. of Customer First Name<sup>*</sup>
                </label>
                <Dropdown />
              </div>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Column No. of Customer Last Name<sup>*</sup>
                </label>
                <Dropdown />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Column No. of Address1<sup>*</sup>
                </label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Column No. of Address2<sup>*</sup>
                </label>
                <input type="text" />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer}>
                <label htmlFor="">Enter Column No. of Address3</label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Column No. of E-mail Id<sup>*</sup>
                </label>
                <input type="text" />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Column No. of Phone No.<sup>*</sup>
                </label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Column No. of Membership Id<sup>*</sup>
                </label>
                <input type="text" />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Column No. of Employee Id<sup>*</sup>
                </label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Column No. of Referral Id(Membership Id)<sup>*</sup>
                </label>
                <input type="text" />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Column No. of Enroll Date<sup>*</sup>
                </label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Column No. of Date of Birth<sup>*</sup>
                </label>
                <input type="text" />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Column No. of Gender<sup>*</sup>
                </label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Column No. of Country<sup>*</sup>
                </label>
                <input type="text" />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Column No. of State<sup>*</sup>
                </label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer}>
                <label htmlFor="">
                  Enter Column No. of City<sup>*</sup>
                </label>
                <input type="text" />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer}>
                <label htmlFor="">Column Name for Field 1</label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer}>
                <label htmlFor="">Column No. of Field 1</label>
                <input type="text" />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer}>
                <label htmlFor="">Column Name for Field 2</label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer}>
                <label htmlFor="">Column No. of Field 2</label>
                <input type="text" />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer}>
                <label htmlFor="">Column Name for Field 3</label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer}>
                <label htmlFor="">Column No. of Field 3</label>
                <input type="text" />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer}>
                <label htmlFor="">Column Name for Field 4</label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer}>
                <label htmlFor="">Column No. of Field 4</label>
                <input type="text" />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer}>
                <label htmlFor="">Column No. of Field 5</label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer}>
                <label htmlFor="">Column No. of Field 5</label>
                <input type="text" />
              </div>
            </div>

            <div className={styles.buttonContainer}>
              <button className={styles.submit}>Submit</button>
              <button
                className={styles.reset}
                type="button"
                onClick={() => setClearModal(true)}>
                Reset
              </button>
            </div>
          </div>
          <div className={styles.tableSection}>
            <div className={styles.searchInputContainer}>
              <div className={styles.searchInput}>
                <SearchInput />
              </div>
              <button className={styles.searchBTN}>Search</button>
            </div>
            <div className={styles.innerTableContainer}>
              <table className={styles.mainTable}>
                <thead>
                  <tr>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Brand Name</th>
                    <th>Year & Month</th>
                    <th>Opening Quantity</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map(each => (
                    <tr key={each.id}>
                      <td>{each.code}</td>
                      <td>{each.name}</td>
                      <td>{each.itemName}</td>
                      <td>{each.groupName}</td>
                      <td>{each.brandName}</td>

                      <td>
                        <div className={styles.iconContainer}>
                          <span className={styles.icon}>
                            <ViewPen />
                          </span>
                          <span
                            className={styles.icon}
                            onClick={() => setDeleteModal(true)}>
                            <Times />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {/* Pass your clear input function to clearInputFn */}
          <ClearInputModal
            //   clearInputFn={handleReset}
            clearModalStatus={clearModal}
            clearInputModalState={setClearModal}
          />
        </div>
      </CallCenterStructure>
    </div>
  );
};

export default DataMappingForEnrollment;
